import React from 'react';
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";

interface EmbedCodeSectionProps {
  embedCode: string;
}

export const EmbedCodeSection = ({ embedCode }: EmbedCodeSectionProps) => {
  const { toast } = useToast();

  const handleCopyCode = () => {
    navigator.clipboard.writeText(embedCode);
    toast({
      title: "Code copied!",
      description: "The badge code has been copied to your clipboard.",
    });
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h4 className="font-medium">Embed Code</h4>
        <Button
          onClick={handleCopyCode}
          variant="secondary"
          size="sm"
          className="text-sm text-white bg-[#174996] hover:bg-[#0d2b59]"
        >
          Copy code
        </Button>
      </div>
      <div className="relative">
        <pre className="bg-gray-50 p-4 rounded-lg overflow-x-auto text-sm font-mono max-h-[200px]">
          {embedCode}
        </pre>
      </div>
    </div>
  );
};